import axios from 'axios';
import { handleResponse, handleError } from '@/services/api/utils/response.js';
import { apiProvider } from '@/services/api/utils/provider.js';

const getSubmittalsDataElements = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/submittals/data-elements`)
		.then(handleResponse)
		.catch(handleError);
};

const submittalsDataElementsApi = { getSubmittalsDataElements };
export default submittalsDataElementsApi;
